import en from "./en.json";
import tr from "./tr.json";

const languages = {
  en,
  tr,
};

export default languages;
